













































import Vue from 'vue'
import TaskType from '@/enums/taskType'

export default Vue.extend({
  name: 'TaskListModal',

  props: {
    modalVisible: {
      type: Boolean,
      required: true,
    },
    businessBrand: {
      type: String,
      required: true,
    },
    proofTypes: {
      type: Array,
      required: true,
    },
    completedProofTypes: {
      type: Array,
      required: true,
    },
  },

  computed: {
    taskTypes: function () {
      return Object.values(TaskType).reduce((reducer: object[], task: any) => {
        if (!this.proofTypes.includes(task.type)) return reducer

        reducer.push({
          ...task,
          title: task.title.replace(' ', '<br>'),
          complete: this.completedProofTypes.includes(task.type),
        })

        return reducer
      }, [])
    },
  },

  methods: {
    onProofTypeSelected: function (type) {
      const voucherId = this.$router.currentRoute.params.voucherId
      this.$router.replace({ path: `/proof/${type.urlSlug}/${voucherId}` })
    },
  },
})
